var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyNavBar',{attrs:{"title":"科普宣教-医生推送"}}),_c('div',{staticStyle:{"text-align":"center","padding":"16px"}},[_vm._v("当前为演示模式")]),_c('div',{staticStyle:{"padding":"16px"}},[_c('ListPageV3',{attrs:{"datas":_vm.datas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }